import React from "react";
// import { EflowLoginFooter } from "../Login/EflowLoginFooter/EflowLoginFooter";
import { AdminHeader } from "../Admin/AdminHeader/AdminHeader";
import { AdminMenu } from "../Admin/AdminMenu/AdminMenu";
import { Icon } from "../Icon/Icon";
import { UserMenu } from "../User/UserMenu/UserMenu";
import "./Layout.css";

export const LoginLayout = ({ children }) => {
  return (
    <div className="Layout">
      <div className="Layout__left">
        <div className="Layout__icons">
          {/* Hide these until after onboarding is through */}
          {/*           
          <Icon name="iconEflowWhite" width={35} height={35} />
          <Icon name="iconWorkflow" width={35} height={35} />
          <Icon name="iconInventory" width={35} height={35} /> */}
          <Icon name="iconEflowFull" width={100} height={35} />
        </div>
      </div>
      {children}
    </div>
  );
};

export const AdminLayout = ({ role, children }) => {
  return (
    <div className="AdminLayout">
      <div className="AdminLayout__menu">
        <AdminMenu role={role} />
      </div>
      <div className="AdminLayout__main">
        <div className="AdminLayout__header-bar">
          <AdminHeader />
        </div>
        <div className="AdminLayout__content">{children}</div>
      </div>
    </div>
  );
};

export const UserLayout = ({ role, children }) => {
  return (
    <div className="AdminLayout">
      <div className="AdminLayout__menu">
        <UserMenu />
      </div>
      <div className="AdminLayout__main">
        <div className="AdminLayout__header-bar">
          <AdminHeader />
        </div>
        <div className="AdminLayout__content">{children}</div>
      </div>
    </div>
  );
};
